<template>
  <div>
    <DialogCouponSuccess ref="DialogCouponSuccess" />
    <DialogQRFail ref="QRFail" failTitle="読み込みがうまくいきませんでした" />
  </div>
</template>

<script>
import API from "@/API";
import userInfoService from "@/services/userInfo";

import { mapGetters } from "vuex";

export default {
  name: "TemplateCPN",
  data() {
    return {
      isTargetVersionForValidateProfileWithBirthDate: true,
    };
  },
  computed: {
    ...mapGetters("common", ["device", "appVersion"]),
  },
  methods: {
    async CPN() {
      // 該当MasterBook情報を取得
      await API.getMasterBook(this.$route.query.master_book_id);

      // 登録が必要で、未登録ならプロファイル未登録ダイアログを表示して処理終了
      if (
        !(await userInfoService.checkProfile(
          this.isTargetVersionForValidateProfileWithBirthDate
        ))
      ) {
        return false;
      }

      try {
        await API.postCreateCouponBookGroup(
          `${this.$route.fullPath.split("?")[1]}`,
          null
        );

        // 成功したダイアログ
        this.$refs.DialogCouponSuccess.openDialog();
      } catch (err) {
        // 失敗したらダイアログ
        this.$refs.QRFail.openDialog();
      }
    },
    checkVersion() {
      console.log("this.appVersion::", this.appVersion);
      console.log("this.device::", this.device);
      // check version to use birth_date
      let isTargetVersionForValidateProfileWithBirthDateValue = false;

      switch (this.device) {
        case "IOS":
          // check version to use birth_date
          isTargetVersionForValidateProfileWithBirthDateValue =
            this.convertVersionForCompare(this.appVersion) <
            this.convertVersionForCompare("2.8.2");
          break;
        case "ANDROID":
          // check version to use birth_date
          isTargetVersionForValidateProfileWithBirthDateValue =
            this.convertVersionForCompare(this.appVersion) <
            this.convertVersionForCompare("2.8.3");
          break;
        default:
          isTargetVersionForValidateProfileWithBirthDateValue = false;
          break;
      }
      // check version to use birth_year
      this.isTargetVersionForValidateProfileWithBirthDate =
        isTargetVersionForValidateProfileWithBirthDateValue;
    },
    convertVersionForCompare(ver) {
      const verNums = ver.split(".");
      return verNums[0] * 100 + verNums[1] * 10 + verNums[2];
    },
  },
  watch: {
    appVersion(value) {
      this.checkVersion();
    },
  },
};
</script>
